import React, { useState, useEffect } from "react";
import PageShell from "../components/layout/PageShell";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Mediatheque() {
  useScrollReveal();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const categories = [
    { id: "all", label: "Tout" },
    { id: "promotions", label: "Promotions" },
    { id: "proces-fictifs", label: "Procès fictifs" },
  ];

  const galleryPhotos = [
    { id: 1, src: "/media/photos/proces1.jpeg", category: "proces-fictifs", title: "Simulation audience civile", desc: "Procès fictif - Promotion 2025-2027", tall: true },
    { id: 2, src: "/media/photos/proces2.jpeg", category: "proces-fictifs", title: "Préparation des participants", desc: "Procès fictif - Promotion 2025-2027", tall: false },
    { id: 3, src: "/media/photos/proces3.jpeg", category: "proces-fictifs", title: "Audience pénale", desc: "Procès fictif - Promotion 2025-2027", tall: false },
    { id: 4, src: "/media/photos/proces4.jpeg", category: "proces-fictifs", title: "Délibération du jury", desc: "Procès fictif - Promotion 2025-2027", tall: true },
    { id: 5, src: "/media/photos/proces5.jpeg", category: "proces-fictifs", title: "Remise des prix", desc: "Procès fictif - Promotion 2025-2027", tall: false },
    { id: 6, src: "/media/photos/proces6.jpeg", category: "proces-fictifs", title: "Cérémonie de clôture", desc: "Procès fictif - Promotion 2025-2027", tall: true },
    { id: 7, src: "/media/photos/promotion8_1.jpg", category: "promotions", title: "Promotion 8 - Ouverture", desc: "Cérémonie d'ouverture 2025-2027", tall: false },
    { id: 8, src: "/media/photos/promotion8_2.jpg", category: "promotions", title: "Promotion 8 - Cours", desc: "Séance pédagogique", tall: true },
    { id: 9, src: "/media/photos/promotion8_3.jpg", category: "promotions", title: "Promotion 8 - Groupe", desc: "Élèves magistrats", tall: false },
    { id: 10, src: "/media/photos/promotion8_4.jpg", category: "promotions", title: "Promotion 8 - Atelier", desc: "Travaux pratiques", tall: false },
    { id: 11, src: "/media/photos/promotion8_5.jpg", category: "promotions", title: "Promotion 8 - Cérémonie", desc: "Cérémonie officielle", tall: true },
  ];

  const filteredPhotos = selectedCategory === "all"
    ? galleryPhotos
    : galleryPhotos.filter(photo => photo.category === selectedCategory);

  const videos = [
    {
      title: "Témoignage d'élève-magistrat",
      desc: "Capsule mettant en valeur l'expérience d'un élève-magistrat au sein de l'École de la Magistrature.",
      src: "/media/videos/eleve.mp4",
    },
    {
      title: "Récapitulatif institutionnel",
      desc: "Vidéo récapitulative présentant les activités, moments forts et temps marquants de la vie institutionnelle.",
      src: "/media/videos/recap.mp4",
    },
  ];

  useEffect(() => {
    const handleKey = (e) => {
      if (lightboxIndex === null) return;
      if (e.key === "Escape") setLightboxIndex(null);
      if (e.key === "ArrowRight") setLightboxIndex((prev) => (prev + 1) % filteredPhotos.length);
      if (e.key === "ArrowLeft") setLightboxIndex((prev) => (prev - 1 + filteredPhotos.length) % filteredPhotos.length);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxIndex, filteredPhotos.length]);

  return (
    <PageShell
      title="Médiathèque"
      subtitle="Photos, vidéos et moments clés de la vie institutionnelle de l'EMA."
    >
      {/* Hero Mosaic */}
      <section className="ema-reveal" style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr',
        gridTemplateRows: '200px 200px',
        gap: '8px',
        borderRadius: '20px',
        overflow: 'hidden',
        marginBottom: '48px'
      }}>
        <div style={{ gridRow: '1 / 3', position: 'relative', cursor: 'pointer' }} onClick={() => setLightboxIndex(0)}>
          <img src="/media/photos/proces1.jpeg" alt="Hero" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '24px', background: 'linear-gradient(transparent, rgba(0,0,0,0.8))' }}>
            <span style={{ color: '#D4AF37', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>Galerie photos</span>
            <h2 style={{ color: '#fff', fontSize: '24px', fontWeight: 800, marginTop: '4px' }}>Moments forts de l'EMA</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginTop: '4px' }}>{galleryPhotos.length} photos</p>
          </div>
        </div>
        <div style={{ cursor: 'pointer', overflow: 'hidden' }} onClick={() => setLightboxIndex(1)}>
          <img src="/media/photos/promotion8_1.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} onMouseOver={e => e.currentTarget.style.transform='scale(1.08)'} onMouseOut={e => e.currentTarget.style.transform='scale(1)'} />
        </div>
        <div style={{ cursor: 'pointer', overflow: 'hidden' }} onClick={() => setLightboxIndex(2)}>
          <img src="/media/photos/proces3.jpeg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} onMouseOver={e => e.currentTarget.style.transform='scale(1.08)'} onMouseOut={e => e.currentTarget.style.transform='scale(1)'} />
        </div>
        <div style={{ cursor: 'pointer', overflow: 'hidden' }} onClick={() => setLightboxIndex(6)}>
          <img src="/media/photos/promotion8_2.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} onMouseOver={e => e.currentTarget.style.transform='scale(1.08)'} onMouseOut={e => e.currentTarget.style.transform='scale(1)'} />
        </div>
        <div style={{ cursor: 'pointer', overflow: 'hidden', position: 'relative' }} onClick={() => setLightboxIndex(4)}>
          <img src="/media/photos/proces5.jpeg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }} onMouseOver={e => e.currentTarget.style.transform='scale(1.08)'} onMouseOut={e => e.currentTarget.style.transform='scale(1)'} />
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(11,44,95,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: '#fff', fontSize: '18px', fontWeight: 700 }}>+{galleryPhotos.length - 5} photos</span>
          </div>
        </div>
      </section>

      {/* Filtres */}
      <section className="ema-reveal">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '32px',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                style={{
                  padding: '10px 20px',
                  borderRadius: '100px',
                  border: selectedCategory === cat.id ? '2px solid #0B2C5F' : '2px solid transparent',
                  background: selectedCategory === cat.id ? '#0B2C5F' : '#f3f4f6',
                  color: selectedCategory === cat.id ? '#fff' : '#374151',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                {cat.label}
              </button>
            ))}
          </div>
          <span style={{ fontSize: '14px', color: '#6B7280', fontWeight: 500 }}>
            {filteredPhotos.length} photo{filteredPhotos.length > 1 ? 's' : ''}
          </span>
        </div>
      </section>

      {/* Masonry Gallery */}
      <section className="ema-reveal" style={{
        columns: '3 280px',
        columnGap: '16px',
        marginBottom: '48px'
      }}>
        {filteredPhotos.map((photo, idx) => (
          <div
            key={photo.id}
            onClick={() => setLightboxIndex(idx)}
            style={{
              breakInside: 'avoid',
              marginBottom: '16px',
              borderRadius: '16px',
              overflow: 'hidden',
              cursor: 'pointer',
              position: 'relative',
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(11,44,95,0.15)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
            }}
          >
            <img
              src={photo.src}
              alt={photo.title}
              style={{
                width: '100%',
                height: photo.tall ? '340px' : '220px',
                objectFit: 'cover',
                display: 'block'
              }}
            />
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(transparent 50%, rgba(0,0,0,0.75) 100%)',
              opacity: 0,
              transition: 'opacity 0.3s ease',
              display: 'flex',
              alignItems: 'flex-end',
              padding: '20px'
            }}
              onMouseOver={(e) => e.currentTarget.style.opacity = '1'}
              onMouseOut={(e) => e.currentTarget.style.opacity = '0'}
            >
              <div>
                <h3 style={{ color: '#fff', fontSize: '15px', fontWeight: 700, marginBottom: '4px' }}>{photo.title}</h3>
                <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>{photo.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </section>

      {filteredPhotos.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9CA3AF' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ margin: '0 auto 16px' }}>
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
          </svg>
          <p style={{ fontSize: '16px', fontWeight: 600 }}>Aucune photo dans cette catégorie</p>
          <p style={{ fontSize: '14px', marginTop: '4px' }}>Revenez bientôt pour de nouveaux contenus.</p>
        </div>
      )}

      {/* Galerie externe */}
      <section className="ema-reveal" style={{
        background: 'linear-gradient(135deg, #0B2C5F 0%, #1e3a6e 100%)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '24px'
      }}>
        <div>
          <h3 style={{ color: '#fff', fontSize: '20px', fontWeight: 800, marginBottom: '8px' }}>
            Galerie photo officielle
          </h3>
          <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '14px', maxWidth: '480px' }}>
            Accédez à la collection complète des événements et activités de l'EMA, avec des albums professionnels couvrant les temps forts institutionnels.
          </p>
        </div>
        <a
          href="https://gallery.eddyprincivilvisuals.com/ema/#"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '14px 28px',
            background: '#D4AF37',
            color: '#071b3b',
            borderRadius: '12px',
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: '14px',
            transition: 'all 0.3s ease'
          }}
        >
          Consulter la galerie
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 17L17 7"/><path d="M7 7h10v10"/>
          </svg>
        </a>
      </section>

      {/* Vidéos */}
      <section className="ema-reveal">
        <div style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '24px', fontWeight: 800, color: '#0B2C5F', marginBottom: '8px' }}>Vidéos</h2>
          <p style={{ fontSize: '15px', color: '#6B7280' }}>
            Une sélection de vidéos mettant en lumière les activités et témoignages de l'EMA.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px' }}>
          {videos.map((video) => (
            <div key={video.title} style={{
              borderRadius: '16px',
              overflow: 'hidden',
              background: '#fff',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)';
              }}
            >
              <div style={{ position: 'relative', background: '#000' }}>
                <video
                  controls
                  preload="metadata"
                  playsInline
                  style={{ width: '100%', display: 'block', aspectRatio: '16/9', objectFit: 'cover' }}
                >
                  <source src={video.src} type="video/mp4" />
                </video>
              </div>
              <div style={{ padding: '20px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#0B2C5F', marginBottom: '8px' }}>{video.title}</h3>
                <p style={{ fontSize: '13px', color: '#6B7280', lineHeight: 1.6 }}>{video.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.95)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.2s ease'
          }}
          onClick={() => setLightboxIndex(null)}
        >
          {/* Fermer */}
          <button
            onClick={() => setLightboxIndex(null)}
            style={{
              position: 'absolute',
              top: '24px',
              right: '24px',
              width: '44px',
              height: '44px',
              borderRadius: '50%',
              border: 'none',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(8px)',
              color: '#fff',
              fontSize: '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10001,
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
          >
            ✕
          </button>

          {/* Compteur */}
          <div style={{ position: 'absolute', top: '28px', left: '50%', transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.7)', fontSize: '14px', fontWeight: 600 }}>
            {lightboxIndex + 1} / {filteredPhotos.length}
          </div>

          {/* Précédent */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIndex((prev) => (prev - 1 + filteredPhotos.length) % filteredPhotos.length);
            }}
            style={{
              position: 'absolute',
              left: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '52px',
              height: '52px',
              borderRadius: '50%',
              border: 'none',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(8px)',
              color: '#fff',
              fontSize: '28px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10001,
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
          >
            ‹
          </button>

          {/* Suivant */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIndex((prev) => (prev + 1) % filteredPhotos.length);
            }}
            style={{
              position: 'absolute',
              right: '24px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '52px',
              height: '52px',
              borderRadius: '50%',
              border: 'none',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(8px)',
              color: '#fff',
              fontSize: '28px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10001,
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
          >
            ›
          </button>

          {/* Image */}
          <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: '85vw', maxHeight: '85vh', textAlign: 'center' }}>
            <img
              src={filteredPhotos[lightboxIndex].src}
              alt={filteredPhotos[lightboxIndex].title}
              style={{
                maxWidth: '100%',
                maxHeight: '78vh',
                objectFit: 'contain',
                borderRadius: '12px',
                boxShadow: '0 16px 60px rgba(0,0,0,0.5)'
              }}
            />
            <div style={{ marginTop: '20px', color: '#fff' }}>
              <h3 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px' }}>
                {filteredPhotos[lightboxIndex].title}
              </h3>
              <p style={{ fontSize: '14px', opacity: 0.7 }}>
                {filteredPhotos[lightboxIndex].desc}
              </p>
            </div>
          </div>
        </div>
      )}
    </PageShell>
  );
}